module.exports = __webpack_public_path__ + "static/img/banner_home_started.ea7749e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/banner_home_started.png
// module id = CnhX
// module chunks = 31